module.exports = __webpack_public_path__ + "img/vedioPic.bbddb683.png";